import { LegalLayout } from "./LegalLayout";

export default function AGB() {
  return (
    <LegalLayout
      eyebrow="Rechtliches"
      title={<>Allgemeine <em>Geschäftsbedingungen</em></>}
      updated="12. Mai 2026"
    >
      <h2>§ 1 Geltungsbereich</h2>
      <p>
        Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle
        Verträge, die zwischen der tino24/7 GmbH (im Folgenden
        „Vitanara") und einer natürlichen Person (im Folgenden „Kunde")
        über die Erstellung einer KI-gestützten Biografie geschlossen
        werden. Abweichende Bedingungen des Kunden werden nicht anerkannt,
        es sei denn, ihrer Geltung wird ausdrücklich schriftlich zugestimmt.
      </p>

      <h2>§ 2 Vertragspartner</h2>
      <p>
        Vertragspartner ist die <strong>tino24/7 GmbH</strong>,
        Ringbahnstr.&nbsp;42, 12099&nbsp;Berlin, vertreten durch den
        Geschäftsführer Kai Först, eingetragen im Handelsregister des
        Amtsgerichts Berlin Charlottenburg unter HRB&nbsp;256376&nbsp;B.
      </p>

      <h2>§ 3 Vertragsgegenstand</h2>
      <p>
        Vitanara erstellt auf Grundlage telefonisch geführter Interviews
        eine individuelle Lebensbiografie. Die Interviews werden von einem
        KI-gesteuerten Sprachsystem (Konrad oder Ida) geführt. Die
        Auslieferung erfolgt — je nach gewähltem Paket — als gedrucktes
        Buch, Hörbuch und/oder als Podcast-Stream im persönlichen Bereich
        auf vitanara.de.
      </p>

      <h2>§ 4 Vertragsabschluss</h2>
      <p>
        Der Vertrag kommt durch die Online-Anmeldung des Kunden auf
        vitanara.de und die anschließende Bestätigung per E-Mail durch
        Vitanara zustande. Mit dem Versand einer handgeschriebenen
        Postkarte mit der Telefonnummer an die Erzählerin oder den Erzähler
        beginnt die aktive Leistungserbringung.
      </p>

      <h2>§ 5 Leistungsumfang</h2>
      <p>
        Der Standard-Leistungsumfang umfasst:
      </p>
      <ul>
        <li>
          Bis zu <strong>12 Wochen</strong> Aufnahme-Phase, in der die
          Erzählerin / der Erzähler unter der Vitanara-Telefonnummer
          beliebig oft anrufen kann.
        </li>
        <li>
          Strukturierung der Inhalte in bis zu{" "}
          <strong>13 biografische Kapitel</strong>.
        </li>
        <li>
          Auslieferung als <strong>Leinen-gebundenes Buch</strong>{" "}
          (Standard 184 Seiten).
        </li>
      </ul>
      <p>
        Erweiterungen (zusätzliche Seiten, weitere Exemplare, Hörbuch,
        Podcast) sind buchbar. Die genauen Umfänge ergeben sich aus dem
        gewählten Paket bei der Bestellung.
      </p>

      <h2>§ 6 Preise und Zahlung</h2>
      <p>
        Der Einstiegspreis beginnt bei <strong>79 €</strong>. Die genauen
        Pakete und Preise werden im Laufe der Zeit auf vitanara.de
        veröffentlicht. Die Zahlung erfolgt online — vorbehaltlich der
        Integration — über Stripe. Alle Preise verstehen sich inkl.
        gesetzlicher Mehrwertsteuer.
      </p>

      <h2>§ 7 Mitwirkungspflichten</h2>
      <p>
        Der Kunde stellt eine korrekte Telefonnummer der Erzählerin / des
        Erzählers zur Verfügung, damit eingehende Anrufe der Caller-ID
        zugeordnet werden können. Bei Änderung der Telefonnummer ist
        Vitanara unverzüglich zu informieren.
      </p>

      <h2>§ 8 Widerrufsrecht für Verbraucher</h2>
      <p>
        Verbraucher haben das Recht, binnen <strong>14 Tagen</strong> ohne
        Angabe von Gründen den Vertrag zu widerrufen. Die Widerrufsfrist
        beginnt mit dem Tag des Vertragsschlusses. Zur Wahrung der Frist
        genügt die rechtzeitige Absendung der Widerrufserklärung an{" "}
        <a href="mailto:info@vitanara.de">info@vitanara.de</a>.
      </p>
      <p>
        <strong>Erlöschen des Widerrufsrechts:</strong> Das Widerrufsrecht
        erlischt vorzeitig, wenn die Leistung — etwa das erste
        Telefongespräch — bereits begonnen hat und der Kunde dem
        ausdrücklich zugestimmt hat.
      </p>

      <h2>§ 9 Datenschutz</h2>
      <p>
        Es gelten die Bestimmungen unserer{" "}
        <a href="/datenschutz">Datenschutzerklärung</a>. Der Kunde ist
        verpflichtet, die Erzählerin / den Erzähler vor dem ersten Anruf
        über die Aufzeichnung und Verarbeitung der Gespräche zu
        informieren. Zusätzlich wird die Einwilligung am Anfang jedes
        Telefongesprächs eingeholt.
      </p>

      <h2>§ 10 Urheberrecht und Nutzungsrechte</h2>
      <p>
        Die in den Telefongesprächen entstehenden Inhalte gehören
        ausschließlich der erzählenden Person bzw. — bei einem Geschenk —
        dem Auftraggeber. Vitanara erhält kein Verwertungsrecht; eine
        kommerzielle Nutzung der Inhalte durch Vitanara ist ausgeschlossen.
        Vitanara kann anonymisierte und ausdrücklich freigegebene Auszüge
        zu Demonstrationszwecken verwenden.
      </p>

      <h2>§ 11 Haftung</h2>
      <p>
        Vitanara haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit
        sowie für Schäden aus der Verletzung des Lebens, des Körpers oder
        der Gesundheit. Im Übrigen ist die Haftung auf den vertragstypisch
        vorhersehbaren Schaden begrenzt. Eine Haftung für entgangene
        Gewinne oder mittelbare Schäden ist ausgeschlossen.
      </p>

      <h2>§ 12 Schlussbestimmungen</h2>
      <p>
        Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts.
        Gerichtsstand für alle Streitigkeiten aus diesem Vertrag ist —
        soweit gesetzlich zulässig — Berlin.
      </p>
      <p>
        Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder
        werden, berührt dies die Wirksamkeit der übrigen Bestimmungen
        nicht (salvatorische Klausel).
      </p>
    </LegalLayout>
  );
}
